import Amplify from 'aws-amplify';


import AmplifyConf from './amplifyConfig';
import API from './modules';

Amplify.configure(AmplifyConf);

export default API;